module.exports = __webpack_public_path__ + "static/img/bg-donations-slider.c7de08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-donations-slider.jpg
// module id = 3BEf
// module chunks = 1